import { Component } from '@angular/core';

import { FLOCK_VARIANT } from '../../../models/flock.model';
import { FlockOverviewVariantConfig } from '../../shared/flock-variant.config';

export const BREEDER_FLOCK_OVERVIEW_CONFIG: FlockOverviewVariantConfig = {
  flockVariant: FLOCK_VARIANT.Breeder,
  newFlockTranslationKey: 'flock-overview.new-breeder-flock',
  deleteFlockTranslationKey: 'flock-overview.panel.delete-breeder-flock',
  showLayerActions: false,
  showBreederFields: true,
  loadRearingOrganizations: true,
  arrivalDetail: {
    flockVariant: FLOCK_VARIANT.Breeder,
    productionPeriod: {
      startInDays: 154,
      startWeekNr: 22,
    },
  },
  weekRegistration: {
    productionPeriod: {
      startInDays: 154,
      startWeekNr: 22,
      fullFirstWeekFromArrival: true,
    },
  },
};

@Component({
  selector: 'app-breeder-flock-overview',
  templateUrl: './breeder-flock-overview.component.html',
  standalone: false,
})
export class BreederFlockOverviewComponent {
  readonly config = BREEDER_FLOCK_OVERVIEW_CONFIG;
}
